import { getAdminAuthHeaders } from "./adminAuth";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_GRAPHQL_URI?.replace(/\/graphql\/?$/, "") ||
  "http://localhost:8080";

export async function uploadImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE}/api/images/upload`, {
    method: "POST",
    headers: getAdminAuthHeaders(),
    body: formData,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || "Image upload failed");
  }

  const data = (await response.json()) as { url: string };
  return data.url;
}
